<div
  *ngIf="isAvailable"
  [class.active]="isActive"
  [class.with-label]="label"
  [class.with-counter]="counter !== undefined"
  [class.with-icon]="iconName"
  class="button-container"
>
  <ng-container *ngIf="type === 'view-switcher'">
    <rt-dot *ngIf="isUnread" color="unread" margin-right-small-xx></rt-dot>
    <div *ngIf="iconName" class="icon-container">
      <rt-icon [name]="iconName" [size]="'small'"></rt-icon>
    </div>
    <div *ngIf="label" class="label-container">
      {{ label }}
    </div>
    <rt-badge
      *ngIf="counter !== undefined && counter !== null"
      color="counter-light"
      [text]="counter"
    ></rt-badge>
  </ng-container>
  <div *ngIf="type === 'multilang-switcher'" class="multilang-container">
    <ng-container>
      <div class="text">
        {{ language.name }}
        <span *ngIf="language.isDefault || language.primary"> ({{ bracketLabel }})</span>
      </div>
      <div *ngIf="loadingLanguageCode === language.code" layout-centered class="spinner-wrap">
        <rt-spinner variant="small"></rt-spinner>
      </div>
      <rt-circular-progress-indicator
        *ngIf="!language.isDefault && loadingLanguageCode !== language.code"
        [percent]="getTranslationProgress(language.translationFieldsCount)"
        [rtTooltip]="getTooltipMessage(language.translationFieldsCount)"
        margin-left-small-x
      >
      </rt-circular-progress-indicator>
    </ng-container>
  </div>
</div>
